import React from 'react';
import './SlideWrapper.css';

export default function SlideWrapper({ children, direction, transitioning }) {
  return (
    <div className={`slide-wrap ${transitioning ? 'slide-wrap--exit' : 'slide-wrap--enter'}`}
         style={{ '--dir': direction }}>
      {children}
    </div>
  );
}
